import React from "react";
import { Container, Typography, Grid, Paper, Box, Card, Divider } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import "./WhyNaahelCyber.css";
import { useSelector } from "react-redux";
import { t } from "../../utils/i18n";

const WhyNaahelCyber = () => {
  const lang = useSelector((state) => state.i18n.lang);
  const { data, status } = useSelector((state) => state.productData.features);
  const naahelFeatures =
    Array.isArray(data) && data.length > 0
      ? data.map((f) => ({
          name: lang === "ar" ? f.title_ar : f.title,
          description: lang === "ar" ? f.subtitle_ar : f.subtitle,
        }))
      : [];

  if (!naahelFeatures || naahelFeatures.length === 0) {
    return null;
  }


  return (
    <Box className="why-naahels" mb={3} id={"why-naahelcyber"}>
      <Box sx={{ px: "0 !important", width: "90%", mx: "auto" }}>
        <Typography
          variant="h1"
          gutterBottom
          sx={{
            color: (theme) => theme.palette.text.main,
            mb: 2,
          }}
        >
          <Typography
            variant="h1"
            fontWeight={100}
            lineHeight={1}
            mb={"0 !important"}
          >
            {t(lang, "features.naahell")}
          </Typography>
          {t(lang, "features.features")}
        </Typography>

        <Card
          elevation={0}
          sx={{
            backgroundColor: (theme) => theme.palette.background.default,
            borderRadius: "16px",
            mt: 4,
            padding: "30px",
          }}
        >
          {(naahelFeatures.length > 0 ? naahelFeatures : []).map(
            (feature, index) => (
              <Box key={index}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 5,
                    pb: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 50,
                      minWidth: 50,
                      height: 50,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      width="50"
                      height="25"
                      viewBox="0 0 72 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M58.5002 0.726703C68.8502 -0.58712 74.9702 10.4919 68.2002 17.7505C57.6302 26.4162 48.1402 37.9704 37.5002 46.3565C32.7002 50.1396 26.6102 51.1925 20.8902 48.3878C17.8202 46.8783 5.61018 35.3986 3.01018 32.4542C-5.84982 22.4281 7.64019 9.9328 18.1102 17.7412C19.9302 19.0923 25.8102 25.5962 27.2802 25.8478C28.1602 25.9969 28.8102 25.6707 29.4302 25.1024C37.5302 18.6823 44.9402 9.11291 53.0902 3.03764C54.6302 1.89154 56.5202 0.978287 58.5002 0.726703Z"
                        fill="#DD3740"
                      />
                    </svg>
                  </Box>
                  <Box>
                    <Typography
                      variant="h4"
                      fontWeight="600"
                      sx={{ mb: 1, color: (theme) => theme.palette.text.main }}
                    >
                      {feature.name}
                    </Typography>
                    <Typography
                      variant="h5"
                      color={(theme) => theme.palette.text.primary}
                      fontWeight={400}
                      sx={{ mb: 2, lineHeight: 1.5 }}
                      dangerouslySetInnerHTML={{ __html: feature.description }}
                    />
                  </Box>
                </Box>
                {index < naahelFeatures.length - 1 && (
                  <Box sx={{ ml: "90px", mb: 2 }}>
                    <Divider sx={{ borderColor: (theme) => theme.palette.text.primary }} />
                  </Box>
                )}
              </Box>
            )
          )}
        </Card>
      </Box>
    </Box>
  );
};

export default WhyNaahelCyber;
